import type { ReactNode } from "react"

export function SwapHeader() {
  return (
    <header className="pb-4">
      <h2 className="flex h-9 items-center font-medium text-gray-900 text-xl/7 tracking-tight">
        Swap
      </h2>
      <p className="font-medium text-gray-500 text-sm/5">
        Check a live price across supported networks.
      </p>
    </header>
  )
}

const LandingSwapShell = ({
  children,
  hideHeader = false,
}: {
  children: ReactNode
  hideHeader?: boolean
}) => {
  return (
    <section className={hideHeader ? undefined : "space-y-4"}>
      {hideHeader ? null : <SwapHeader />}
      {children}
    </section>
  )
}

export default LandingSwapShell
